import React, { useState, useEffect,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateFormData } from "../../redux/dispatch";
import useRubriqueNav from "../../hooks/useRubriqueNav";
import RubriqueNav from "../shared/RubriqueNav";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import "./CourbeCroissance.css";
import toast from 'react-hot-toast';
import { saveDossier } from "../../redux/dispatch";
import SaveLoader from "../shared/SaveLoader";
import { API_BASE } from "../../config/api";
import noImage from "../../assets/no-image.svg";
const RUBRIQUE = "courbe_croissance";

const MenuBar = ({ editor }) => {
  if (!editor) return null;
  const buttons = [
    { label: "G",       title: "Gras",           action: () => editor.chain().focus().toggleBold().run(),                  active: editor.isActive("bold"),           style: { fontWeight: "bold" } },
    { label: "I",       title: "Italique",        action: () => editor.chain().focus().toggleItalic().run(),                active: editor.isActive("italic"),         style: { fontStyle: "italic" } },
    { label: "S",       title: "Barré",           action: () => editor.chain().focus().toggleStrike().run(),                active: editor.isActive("strike"),         style: { textDecoration: "line-through" } },
    { label: "U",       title: "Souligné",        action: () => editor.chain().focus().toggleUnderline().run(),             active: editor.isActive("underline"),      style: { textDecoration: "underline" } },
    { label: "H1",      title: "Titre 1",         action: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),   active: editor.isActive("heading", { level: 1 }) },
    { label: "H2",      title: "Titre 2",         action: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),   active: editor.isActive("heading", { level: 2 }) },
    { label: "• List",  title: "Liste à puces",   action: () => editor.chain().focus().toggleBulletList().run(),            active: editor.isActive("bulletList") },
    { label: "1. List", title: "Liste numérotée", action: () => editor.chain().focus().toggleOrderedList().run(),           active: editor.isActive("orderedList") },
    { label: "❝",       title: "Citation",        action: () => editor.chain().focus().toggleBlockquote().run(),            active: editor.isActive("blockquote") },
    { label: "—",       title: "Séparateur",      action: () => editor.chain().focus().setHorizontalRule().run(),           active: false },
    { label: "↩",       title: "Annuler",         action: () => editor.chain().focus().undo().run(),                       active: false },
    { label: "↪",       title: "Rétablir",        action: () => editor.chain().focus().redo().run(),                       active: false },
  ];
  return (
    <div className="cc-menubar">
      {buttons.map((btn, i) => (
        <button key={i} title={btn.title}
          className={`cc-menubar-btn ${btn.active ? "cc-menubar-btn--active" : ""}`}
          style={btn.style || {}} onClick={btn.action} type="button">
          {btn.label}
        </button>
      ))}
    </div>
  );
};

const CourbeCroissance = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id }   = useParams();
  const rawImages = useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.images || []);
    const IMAGES = rawImages.length > 0
    ? rawImages.map((img) => `${API_BASE}/${img.chemin_image}`)
    : [noImage];
  const { currentDossier, list } = useSelector((s) => s.dossiers);
  const dossier = currentDossier || list.find((d) => d.id === id) || null;
  const formulairesData  = useSelector((s) => s.formulaires.data);
  const savedData = useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.data || "");
    const contentRef = useRef(savedData || "");
  const [imgIndex, setImgIndex] = useState(0);

    const editor = useEditor({
        extensions: [StarterKit],
        content: savedData || "",
        onUpdate: ({ editor }) => {
            contentRef.current = editor.getHTML();
        },
    });
    const [saving, setSaving] = useState(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (editor && savedData) {
      editor.commands.setContent(savedData);
    }
  }, [id]);

// APRÈS
const { goNext, goPrev, goTo, suivante, precedente, indexCourant, total } = useRubriqueNav(RUBRIQUE);

  const handleSave = () => {
     dispatch(updateFormData(id, RUBRIQUE, "data", contentRef.current));
  };

    useEffect(() => {
      return () => {
        handleSave();
      };
    }, []);

    const handleSaveAll = async () => {
        setSaving(true);
        if (!editor) return;
        dispatch(updateFormData(id, RUBRIQUE, "data", editor.getHTML()));
        
            try {
            const result = await dispatch(saveDossier());
            toast.success(result.message);
            navigate("/");
        } catch (err) {
            toast.error(err.response?.data?.message || "Erreur lors de la sauvegarde");
        }
    finally {
    setSaving(false);
  }
  };

  const handleCancel = () => {
    if (editor) editor.commands.setContent(savedData || "");
  };

  if (!dossier) {
    return (
      <div className="cc-no-dossier">
        <p>Aucun dossier sélectionné.</p>
        <button onClick={() => navigate("/")}>Retour à la liste</button>
      </div>
    );
  }

  return (
    <div className="cc-page">
         {saving && <SaveLoader />}
      <header className="cc-header">
        <div className="cc-header-left">
          <button className="cc-back-btn" onClick={() => navigate("/")}>← Retour à la liste</button>
          <div>
            <h1 className="cc-title">Dossier {dossier.numero_dossier || dossier.id}</h1>
            <p className="cc-subtitle">Patient : {dossier.patient} &nbsp;|&nbsp; Service : {dossier.service}</p>
          </div>
        </div>
        <button className="cc-save-btn" onClick={handleSaveAll} disabled={saving}>sauvegarder les modifications</button>
      </header>

      <div className="cc-body">
        <aside className="cc-image-panel">
          <div className="cc-image-header">
            <span className="cc-rubrique-label">Courbe de Croissance</span>
            <span className="cc-image-counter">Image {imgIndex + 1} / {IMAGES.length}</span>
          </div>
          <div className="cc-image-viewer">
            <img src={IMAGES[imgIndex]} alt={`Page ${imgIndex + 1}`} className="cc-image" />
          </div>
          <div className="cc-image-nav">
            <button className="cc-nav-btn" onClick={() => setImgIndex((i) => Math.max(0, i - 1))} disabled={imgIndex === 0}>‹</button>
            <div className="cc-image-dots">
              {IMAGES.map((_, i) => (
                <span key={i} className={`cc-dot ${i === imgIndex ? "cc-dot--active" : ""}`} onClick={() => setImgIndex(i)} />
              ))}
            </div>
            <button className="cc-nav-btn" onClick={() => setImgIndex((i) => Math.min(IMAGES.length - 1, i + 1))} disabled={imgIndex === IMAGES.length - 1}>›</button>
          </div>
        </aside>

        <main className="cc-form-panel">
          <div className="cc-form-scroll">
            <div className="cc-description">
              <h2 className="cc-description-title">Courbe de Croissance</h2>
              <p className="cc-description-text">
              Courbe correspondant à l'âge et au sexe, et ajouter toute note clinique pertinente.
              </p>
            </div>
            <div className="cc-editor-wrapper">
              <MenuBar editor={editor} />
              <EditorContent editor={editor} className="cc-editor" />
            </div>
          </div>

         {/*  <div className="cc-form-actions">
            <button className="cc-btn-save" onClick={handleSave}>Enregistrer</button>
            <button className="cc-btn-cancel" onClick={handleCancel}>Annuler</button>
          </div> */}


<RubriqueNav goNext={goNext} goPrev={goPrev} goTo={goTo} suivante={suivante} precedente={precedente} indexCourant={indexCourant} total={total} />        </main>
      </div>
    </div>
  );
};

export default CourbeCroissance;